import { render, staticRenderFns } from "./CampaignSocialActionSettingsModal.vue?vue&type=template&id=1aa1eeb4&scoped=true&"
import script from "./CampaignSocialActionSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CampaignSocialActionSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSocialActionSettingsModal.vue?vue&type=style&index=0&id=1aa1eeb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1eeb4",
  null
  
)

export default component.exports